import styles from './styles.module.css';
import Image from "@/shared/components/Image/new";

const ListadoNotas = (props) => {
    const IMG_CROP = "3_2_300x200";

    const {
        content
    } = { ...props }

    return (
        <div className={`${styles['list-container']}`}>
            {content.map((el, index) => {
                const title = el.title;
                const subtitle = el.subtitle;
                const url = el.url;

                return (
                    <a href={url} key={`listado-notas-anteriores-${index}`}>
                        <div className={`${styles['note']}`}>
                            <div className={`${styles['img-container']}`}>
                                <Image
                                    element={el}
                                    clipping={IMG_CROP}
                                />
                            </div>
                            <div>
                                <h4 className={`${styles["subtitle"]}`}>{subtitle}</h4>
                                <h3 className={`${styles["title"]}`}>{title}</h3>
                                <div 
                                    className={`${styles['summary']}`} 
                                    dangerouslySetInnerHTML={{ 
                                        __html: el.summary 
                                    }}
                                />
                            </div>
                        </div>
                    </a>
                )
            })}
        </div>
    )
}

export default ListadoNotas;